import { useEffect, useState } from "react";
import { ChevronUp } from "lucide-react";

export default function ScrollToTop() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 500);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const toTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <button
      data-testid="scroll-top-btn"
      onClick={toTop}
      aria-label="Remonter en haut de la page"
      title="Remonter en haut"
      className={`fixed right-4 bottom-[84px] z-40 flex h-11 w-11 items-center justify-center rounded-full bg-white text-[#5c2751] shadow-xl ring-1 ring-black/5 transition-all duration-300 hover:bg-[#5c2751] hover:text-white ${
        visible ? "opacity-100 translate-y-0" : "pointer-events-none opacity-0 translate-y-3"
      }`}
    >
      <ChevronUp className="h-5 w-5" />
    </button>
  );
}
